import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaSignal, FaChartLine, FaListAlt, FaCheckCircle, FaMobileAlt, FaQuestion, FaFile } from 'react-icons/fa';
import './styles/footer.css';


class FooterMenu extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { Translator, footer } = this.props;
    const translation = Translator;
    const { f_button, c_button, co_button, fa_button } = footer;
    return (
    // <div className = "container-fluid footer-container">
    //     <div className = "footer">
    //         <span>Powered by<br/>FABSTECH LIMITED</span>
    //     </div>
    // </div>
    <footer className="footer" style = {{height: "10%",width: "100%",margin: "0px",padding: "0px",textAlign: "center",position: "fixed"}}>
      <div className="container-fluid" style={{padding: "0px",height: "100%"}}>
        <div style={{height: "100%",padding: "0px",width: "100%",background: "#666666",fontFamily: "Abel",fontSize: "0.8em"}}> 
          <ul className="nav nav-pills" style={{height: "100%",padding: "0px"}}>
            <li style={{width: "20%",height: "100%",position: "relative",float: "left",margin: "0px"}}><Link to={`${process.env.PUBLIC_URL}/dashboard/`} style={{paddingLeft: "5px", color: "#ffffff"}}><span style={{fontSize: "1.3em"}}><FaHome /></span><br/>{translation['dashboard_home_button']}</Link></li>
            <li style={{width: "20%",height: "100%",position: "relative",float: "left",margin: "0px"}} className={c_button}><Link to={`${process.env.PUBLIC_URL}/dashboard/growth-chart/`} style = {{color: "#ffffff"}}><span style={{fontSize: "1.3em"}}><FaSignal /></span><br/>{translation['dashboard_chart_button']}</Link></li>
            <li style={{width: "20%",height: "100%",position: "relative",float: "left",margin: "0px"}} className={f_button}><Link to={`${process.env.PUBLIC_URL}/dashboard/past-advice/`} style = {{color: "#ffffff"}}><span style={{fontSize: "1.3em"}}><FaFile /></span><br/>{translation['dashboard_advice_button']}</Link></li>
            <li style={{width: "20%",height: "100%",position: "relative",float: "left",margin: "0px"}} className={fa_button}><Link to={`${process.env.PUBLIC_URL}/dashboard/faqs/`} style = {{color: "#ffffff"}}><span style={{fontSize: "1.3em"}}><FaQuestion /></span><br/>{translation['dashboard_short_faqs_button']}</Link></li>
            <li style={{width: "20%",height: "100%",position: "relative",float: "left",margin: "0px"}} className={co_button}><Link to={`${process.env.PUBLIC_URL}/dashboard/contact-us/`} style={{paddingLeft: "5px", color: "#ffffff"}}><span class="" style={{fontSize: "1.3em"}}><FaMobileAlt /></span><br/>{translation['dashboard_contact_button']}</Link></li>
          </ul>
        </div>
      </div>
    </footer>

    );
  }
}

export default FooterMenu;